import { autoinject } from 'aurelia-framework';
import { I18N } from "aurelia-i18n";

import { Api } from "../../services/api";
import { Location } from "../../models/location";
@autoinject
export class ZoneAdminCard {
	loading: boolean = false;
	message: string = "";
	locations: Array<Location> = new Array<Location>();
	i18n: I18N;
	api: Api;
	constructor(i18n: I18N, api: Api) {
		this.i18n = i18n;
		this.api = api;
	}

	async bind(bindingContext: any, overrideContext: any) {
		await this.getData();
	}

	async getData() {
		this.message = this.i18n.tr("loading-data");
		this.loading = true;
		this.locations = await this.api.getLocations();
		this.loading = false;
	}

	attached() {

	}

	detached() {

	}

}